import React, { useState } from 'react';
interface PreviewPage {
  alt: string;
  src: string;
}
const previewPages: PreviewPage[] = [{
  alt: 'The GLP-1 Guide cover',
  src: 'https://cdn.magicpatterns.com/uploads/2RCGYKBCCVnAp2PXb14tfM/Page_1.png'
}, {
  alt: 'The GLP-1 Guide copyright page',
  src: 'https://cdn.magicpatterns.com/uploads/8qSBtWLVtAG6Ty2unqENYT/page_2.png'
}, {
  alt: 'The GLP-1 Guide introduction page',
  src: 'https://cdn.magicpatterns.com/uploads/sta1fqYFcbnR3N5oq6ghrx/Page_3.png'
}, {
  alt: 'Part One: Understanding Your Medication divider page',
  src: 'https://cdn.magicpatterns.com/uploads/xuKVreD9bGJy8LoJPZyAj3/page_4.png'
}, {
  alt: 'What is GLP-1 Medication page',
  src: 'https://cdn.magicpatterns.com/uploads/nWy95Cvs9voQKXXUqayUSb/page_5.png'
}, {
  alt: 'GLP-1 vial and syringe system page',
  src: 'https://cdn.magicpatterns.com/uploads/jA7f9kFobDrFbpqB1kmm8s/page_6.png'
}];
export function BookletPreview() {
  const [failedPages, setFailedPages] = useState<string[]>([]);
  return <section className="w-full flex flex-col items-center gap-8" aria-label="The GLP-1 Guide preview pages" data-id="element-629" data-mp="ajjoues37hj5">
      {previewPages.map(page => {
      const didFail = failedPages.includes(page.src);
      return <figure key={page.src} className="w-full max-w-[816px] overflow-hidden bg-white shadow-page" data-id="element-630" data-mp="eiitrzdtjeal">
            {didFail ? <div className="flex min-h-[420px] items-center justify-center bg-[#F5F5F0] px-8 text-center text-[#3B3B3B]" role="status" data-id="element-631" data-mp="3mwhkali0u7gp">
                <p className="max-w-sm text-sm leading-relaxed" data-id="element-632" data-mp="lca82l9tbkb">
                  This preview page could not be loaded. Please refresh and try
                  again.
                </p>
              </div> : <img src={page.src} alt={page.alt} className="block h-auto w-full" loading="eager" onError={() => {
          setFailedPages(pages => pages.includes(page.src) ? pages : [...pages, page.src]);
        }} data-id="element-633" data-mp="2z9j8400xplol" />}
          </figure>;
    })}
    </section>;
}